import { Component, Input } from '@angular/core';
import { MailFile } from 'src/app/shared/models/mails/mail-file';
import { IBoxService } from 'src/app/shared/services/i-box.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CropperPosition, Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DocumentEditorService } from 'src/app/shared/services/document-editor.service';
import * as XLSX from 'xlsx';
import * as saveAs from 'file-saver';
import * as async from 'async';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { ParseEmailService } from 'src/app/shared/services/parse-email.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentTemplateDTO } from 'src/app/shared/interfaces/documents/document-template-dto.interface';
import { EmailFileDetailsDTO } from 'src/app/shared/models/iCourrier/email/email-file-details';
import { MailFileDto } from 'src/app/shared/interfaces';
import { PageRenderedEvent } from 'ngx-extended-pdf-viewer';
@Component({
  selector: 'app-courrier-file-viewer',
  templateUrl: './courrier-file-viewer.component.html',
  styleUrls: ['./courrier-file-viewer.component.scss'],
})
export class CourrierFileViewerComponent {
  @Input() set currentFiles(value: MailFileDto) {
    this.savedFile = value;

    if (value) {
      this.onOpenFile(value);
    } else {
      this.curFile = null;
      this.file4Reader = null;
      this.isEmailFile = false;
    }
  }
  @Input() set setHeightforExcelTable(value: string) {
    if (value) {
      this.heightforExcelTable = value;
    }
  }
  public savedFile: MailFileDto;
  public heightforExcelTable: string = '100%';
  public curFile: MailFile;
  public file4Reader: {
    title: string;
    extension: string;
    src: string;
    blob?: Blob;
  };
  public convertedMail: EmailFileDetailsDTO;
  public cFile: File;
  public isFileOpen: boolean = false;
  public loaded: boolean = false;
  public isEmailFile: boolean = false;
  public showNotFound: boolean = false;
  public showOCR: boolean = false;
  public currentPageImageBase64: string = null;
  public dimensions: Dimensions = { width: 0, height: 0 };
  public cropperPosition: CropperPosition = {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 200,
  };
  private croppedImage: Blob = null;
  public currentPage: number = 1;
  public arrayCanvas: { page: number; canvas: HTMLCanvasElement }[] = [];
  public textToCopy: string = null;
  public scale: number = 1;
  public transform: ImageTransform = {};

  public sheetNames: string[] = [];
  public columnsExcel = [];
  public excelData = [];
  public currentIndexFile: number = 0;
  public currentMailID: number;
  public currentMailFileID: number;

  public downloadFileRight: boolean = false;
  public statusValidation: { label: string; value: number; code: string }[] = [];
  public modelTemplates: DocumentTemplateDTO[] = [];

  constructor(
    private iBoxService: IBoxService,
    private toastr: ToastrService,
    public spinner: NgxSpinnerService,
    public itemplate: DocumentEditorService,
    public route: ActivatedRoute,
    private documentsService: DocumentsService,
    private parseEmailService: ParseEmailService
  ) {}

  pageRendered($event: PageRenderedEvent): void {
    const $canvas = $event.source.canvas;
    this.arrayCanvas.push({
      page: $event.pageNumber,
      canvas: $canvas,
    });
  }
  openOCR(): void {
    this.showOCR = true;
    this.arrayCanvas.map((item) => {
      if (item.page === this.currentPage) {
        this.currentPageImageBase64 = null;
        this.currentPageImageBase64 = item.canvas.toDataURL('img/jpeg');
      }
    });
  }
  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.blob;
  }

  cropperReady(dimensions: Dimensions): void {
    this.dimensions = dimensions;
    this.cropperPosition = {
      x1: 150,
      y1: 50,
      x2: 500,
      y2: 200,
    };
  }

  onIframeLoad(): void {
    const iframe = document.getElementById('file4ReaderIframe') as HTMLIFrameElement;
    iframe.style.height = iframe.contentWindow.document.documentElement.scrollHeight + 'px';
  }

  onOpenFile(file: MailFileDto): void {
    const routeParams = this.route.snapshot.params;
    if (routeParams.mode === null || routeParams.mode !== 'edit') {
      this.curFile = null;
      this.isEmailFile = false;
      this.loaded = false;
      if (file) {
        this.curFile = file;
        this.isFileOpen = true;
        this.iBoxService.downLoadFile(file['mailId'], file['id']).subscribe({
          next: (response) => {
            const blob = new Blob([response], { type: response.type });
            this.file4Reader = {
              title: file.name,
              extension: file.extension.toLowerCase(),
              src: window.URL.createObjectURL(blob),
            };
            if (this.file4Reader.extension === 'eml' || this.file4Reader.extension === 'msg') {
              this.parseEmailFile(blob);
            }
            if (this.file4Reader.extension === 'rtf' || this.file4Reader.extension === 'txt' || this.file4Reader.extension === 'docx') {
              // On ne le fait pas pour l'instant, désolée. Je vous laisse le code qui a été repris du component courrier-create-add-files ;) Faut le tester, pas pu voir si dans savedFile on a tout ce qu'il nous faut
              //En gros, on choppe les droits pour afficher ou non le fait d'imprimer et download le fichier :)
              // AVA 🦊
              // this.getDatasForRights().then(() => {
              // this.checkDowloadRight(this.savedFile).then(() => {
              this.file4Reader.blob = response;
              this.cFile = new File([response], file.name, { type: response.type, lastModified: Date.now() });
              // });
              // });
            }
            if (this.file4Reader.extension === 'xlsx') {
              const reader: FileReader = new FileReader();
              reader.readAsBinaryString(blob);
              reader.onload = (e) => {
                /* create workbook */
                const binarystr: string | ArrayBuffer = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
                this.excelData = [];
                this.columnsExcel = [];
                this.sheetNames = [];
                for (let i = 0; i < wb.SheetNames.length; i++) {
                  /* selected the first sheet */
                  const wsname: string = wb.SheetNames[i];
                  this.sheetNames.push(wsname);
                  const ws: XLSX.WorkSheet = wb.Sheets[wsname];
                  const columnsArray: any = XLSX.utils.sheet_to_json(wb.Sheets[wsname], { header: 1 })[0];

                  for (let j = 0; j < columnsArray.length; j++) {
                    columnsArray[j] = { field: columnsArray[j], header: columnsArray[j] };
                  }

                  this.columnsExcel.push(columnsArray);
                  /* save data */
                  this.excelData.push(
                    XLSX.utils.sheet_to_json(ws, {
                      blankrows: false,
                      raw: true,
                      rawNumbers: true,
                    })
                  ); // to get 2d array=> add an object
                }
              };
            }
            this.loaded = true;
            this.spinner.hide();
          },
          error: (error) => {
            console.error('Error : ', error);
            this.toastr.error('Fichier non trouvé');
            this.file4Reader = null;
            this.showNotFound = true;
            this.loaded = false;
            this.spinner.hide();
          },
        });
      } else {
        if (!file) {
          this.file4Reader = null;
        }
        this.loaded = true;
        this.spinner.hide();
      }
    }
  }

  parseEmailFile(file): void {
    this.parseEmailService.parseEmailFile(file, this.file4Reader.extension).subscribe({
      next: (response) => {
        this.isEmailFile = true;
        this.convertedMail = response;
      },
      error: (error) => {
        console.error('Error : ', error);
        this.showNotFound = true;
      },
    });
  }

  parseEmailWithAttachements(mailID: number, fileID: number): void {
    this.parseEmailService.parseEmailAttachments(mailID, fileID).subscribe({
      next: (response) => {
        this.isEmailFile = true;
        this.convertedMail = response;
        this.file4Reader = {
          title: response.fileName,
          extension: response.fileExtension.toLowerCase(),
          src: null,
        };
        this.loaded = true;
      },
      error: (error) => {
        console.error('Error : ', error);
        this.showNotFound = true;
      },
    });
  }

  startOCR(): void {
    if (!this.croppedImage) {
    this.toastr.warning('Veuillez sélectionner une zone avant de lancer l\'OCR.');
    return;
  }
    const imageBytes = this.croppedImage;
    this.spinner.show();
    this.itemplate.postOCR(imageBytes).subscribe({
      next: (res) => {
        this.textToCopy = res.text.replace(/\n/g, '<br/>');
        this.toastr.success('Le texte a été copié dans le presse-papier!');
        navigator.clipboard.writeText(res.text).then(
          function () {
            console.info('Async: Copying to clipboard was successful!');
          },
          function (err) {
            console.error('Async: Could not copy text: ', err);
          }
        );
        this.spinner.hide();
      },
      error: (error) => {
        console.error(error);
        this.toastr.error('Océrisation impossible');
      },
    });
  }

  reset(): void {
    this.textToCopy = null;
    this.cropperPosition = {
      x1: 150,
      y1: 50,
      x2: 500,
      y2: 200,
    };
  }
  b64toBlob(dataURI:string): Blob {
    const parts = dataURI?.split(',');
  if (!parts || parts.length < 2) {
    throw new Error('Invalid base64 image data');
  }
  const byteString = atob(parts[1])
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
  }

  zoomOut(): void {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  zoomIn(): void {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  resetImage(): void {
    this.scale = 1;
    this.transform = {};
  }

  download(file): void {
    if (file) {
      this.iBoxService.downLoadFileAttachement(this.curFile.mailId, this.curFile.id, file.filename).subscribe({
        next: (res: Blob) => {
          const downloadURL = URL.createObjectURL(res);
          if (file.filename) {
            saveAs(downloadURL, file.filename);
          } else {
            this.toastr.error("Impossible de sauver le fichier, il n'y a pas de nom ou d'extension");
          }
        },
        error: (error) => {
          console.error(error);
          this.toastr.error('Impossible de télécharger le fichier.');
        },
      });
    } else {
      this.toastr.error('Impossible de télécharger le fichier.');
    }
  }

  getDatasForRights(): Promise<boolean> {
    return new Promise((resolve) => {
      async.parallel(
        [
          (callback) => {
            this.documentsService.getStatusValidationGlobal().subscribe({
              next: (res) => {
                if (res.length > 0) {
                  res.map((item) => {
                    this.statusValidation.push({ label: item.description, value: item.id, code: item.code });
                  });
                }
                callback();
              },
            });
          },
          (callback) => {
            this.documentsService.getGlobalTemplates().subscribe({
              next: (templates) => {
                this.modelTemplates = templates;
                callback();
              },
            });
          },
        ],
        () => {
          resolve(true);
        }
      );
    });
  }
}
